import { Component, Input, Output, EventEmitter } from "@angular/core";

/**
 * Presentational child for the repeated Message Center tab body
 * (the "today" / "tomorrow" / "yesterday" tabs, which are structurally
 * identical). All displayed values are passed in as @Inputs and every
 * click is re-emitted to the parent so the parent keeps calling the same
 * methods with the same arguments. The only per-tab difference is the
 * argument passed to redirectToReschedule(), supplied via [rescheduleKey].
 */
@Component({
  selector: "app-message-center-tab",
  templateUrl: "./message-center-tab.component.html",
})
export class MessageCenterTabComponent {
  @Input() isUSBased = false;

  // Per-tab varying value: the single argument to redirectToReschedule().
  @Input() rescheduleKey: string;

  // Displayed counts (constant set across the three duplicated tabs).
  @Input() preAuthorizedtodayCount: number;
  @Input() nonAuthorizedtodayCount: number;
  @Input() patientAppointmentsTodayCount: number;
  @Input() preAuthorizedtmrwCount: number;
  @Input() nonAuthorizedtmrwCount: number;
  @Input() patientAppointmentsTmrwCount: number;
  @Input() icCancelledCount: number;
  @Input() patientNoShowCount: number;
  @Input() patientCancelledCount: number;
  @Input() rescheduledCount: number;

  @Output() authorization = new EventEmitter<{ preauthauth: string; type: string }>();
  @Output() cancelAppointment = new EventEmitter<string>();
  @Output() noshow = new EventEmitter<void>();
  @Output() reschedule = new EventEmitter<string>();

  onAuthorization(preauthauth: string, type: string): void {
    this.authorization.emit({ preauthauth, type });
  }

  onCancelAppointment(type: string): void {
    this.cancelAppointment.emit(type);
  }

  onNoshow(): void {
    this.noshow.emit();
  }

  onReschedule(): void {
    this.reschedule.emit(this.rescheduleKey);
  }
}
